module.exports = __webpack_public_path__ + "img/icon_bank_back.5f1657a9.svg";